/**
 * WebSocket Status Indicator
 */

import { useEffect, useState } from 'react';
import { wsClient } from '@/lib/ws';

export default function WSStatus() {
  const [isConnected, setIsConnected] = useState(wsClient.isConnected());

  useEffect(() => {
    const checkConnection = setInterval(() => {
      setIsConnected(wsClient.isConnected());
    }, 1000);

    return () => clearInterval(checkConnection);
  }, []);

  return (
    <div className="flex items-center gap-2">
      <div
        className={`w-2 h-2 rounded-full ${isConnected ? 'bg-green-500' : 'bg-red-500'} animate-pulse`}
      />
      <span className="text-sm text-muted-foreground">
        {isConnected ? 'Live' : 'Disconnected'}
      </span>
    </div>
  );
}


















